import Api from '../_redux/actions/api/_base';

export const handleValidationCpf = async (cpf, yaloId) => {
	const payload = {
		cpf,
		yaloId
	};

	const response = await Api.post('/plans/signature-validation', payload);
	return response;
};
